module.exports = __webpack_public_path__ + "img/instagram.c9b542c9.svg";